import { SandboxEntityType } from "../types/entities";
import { InteractionType, WeightConfig } from "../types/interactions";

const INTERACTION_TYPE_LABELS: Record<InteractionType, string> = {
  view: "View",
  follow: "Follow",
  share: "Share",
  screen_captured: "Screen capture",
  ticket_view: "Ticket view",
  ticket_purchase: "Ticket purchase",
  offer_view: "Offer view",
};

const COMMON_INTERACTION_TYPES = [
  "view",
  "follow",
  "share",
  "screen_captured",
] as const;

const EVENT_ONLY_INTERACTION_TYPES = [
  "ticket_view",
  "ticket_purchase",
  "offer_view",
] as const;

const ALL_INTERACTION_TYPES: InteractionType[] = [
  ...COMMON_INTERACTION_TYPES,
  ...EVENT_ONLY_INTERACTION_TYPES,
];

const INTERACTION_TYPES_FOR: Record<SandboxEntityType, InteractionType[]> = {
  artist: [...COMMON_INTERACTION_TYPES],
  genre: [...COMMON_INTERACTION_TYPES],
  venue: [...COMMON_INTERACTION_TYPES],
  event: [...COMMON_INTERACTION_TYPES, ...EVENT_ONLY_INTERACTION_TYPES],
};

const DEFAULT_INTERACTION_WEIGHTS: WeightConfig = {
  artist: {
    view: 0.2,
    follow: 0.8,
    share: 0.5,
    screen_captured: 0.4,
    ticket_view: 0,
    ticket_purchase: 0,
    offer_view: 0,
  },
  genre: {
    view: 0.1,
    follow: 0.6,
    share: 0.3,
    screen_captured: 0.3,
    ticket_view: 0,
    ticket_purchase: 0,
    offer_view: 0,
  },
  venue: {
    view: 0.2,
    follow: 0.7,
    share: 0.4,
    screen_captured: 0.3,
    ticket_view: 0,
    ticket_purchase: 0,
    offer_view: 0,
  },
  event: {
    view: 0.2,
    follow: 0.5,
    share: 0.4,
    screen_captured: 0.3,
    ticket_view: 0.4,
    ticket_purchase: 0.9,
    offer_view: 0.3,
  },
};

export {
  INTERACTION_TYPE_LABELS,
  COMMON_INTERACTION_TYPES,
  EVENT_ONLY_INTERACTION_TYPES,
  ALL_INTERACTION_TYPES,
  INTERACTION_TYPES_FOR,
  DEFAULT_INTERACTION_WEIGHTS,
};
